<template>
  
  <div class="ui segment" :class="{ loading }">
    <h4 class="ui dividing header">
      Dados do Laudo
      <span v-if="hasInvoice" class="clickable" 
        data-tooltip="Alguns campos não podem ser alterados porque esse laudo está associando a um fechamento" 
        data-inverted="" data-position="right center">
        <i class="info circle orange icon m-l-5 animated flash"></i>
      </span>
    </h4>
    <div class="ui form">                
      <div class="fields">
        <div v-if="hasInvoice" class="three wide field">
          <label class="form-label">Data</label>
          <input :value="$formatDate(cert.date)" readonly="readonly">
        </div>
        <div v-show="!hasInvoice" class="three wide field">
          <label class="form-label">Data <span class="red text">*</span></label>
          <date-picker ref="datePicker" @onChange="onChangeDate" />
        </div>    
        <div v-show="hasInvoice" class="four wide field">
          <label class="form-label">Serviço</label>
          <input :value="cert.service ? cert.service.description : ''" readonly="readonly">
        </div>
        <div v-show="!hasInvoice" class="four wide field">
          <label class="form-label">Serviço <span class="red text">*</span></label>
          <select-dropdown ref="serviceDropdown" @onChange="onChangeService" />
        </div>
        <div v-show="hasInvoice" class="four wide field">
          <label class="form-label">Tipo</label>
          <input :value="cert.serviceType ? cert.serviceType.description : ''" readonly="readonly">
        </div>
        <div v-show="!hasInvoice" class="four wide field">
          <label class="form-label">Tipo <span class="red text">*</span></label>
          <select-dropdown ref="serviceTypeDropdown" @onChange="onChangeServiceType" />
        </div>  
        <div v-show="hasInvoice" class="five wide field">
          <label class="form-label">Colaborador</label>
          <input :value="cert.user ? cert.user.name + ' ' + cert.user.lastName : ''" readonly="readonly">
        </div>
        <div v-show="!hasInvoice" class="five wide field">
          <label class="form-label">Colaborador <span class="red text">*</span></label>
          <user-picker ref="userPicker" :authToken="authToken" :uppercase="true" :onlySimavet="true"
            @onPick="onPickUser" @onClear="onClearUser" />
        </div>                     
      </div>    
      <div class="fields">
        <div v-show="hasInvoice" class="five wide field">
          <label class="form-label">Clínica</label>
          <input :value="cert.customer ? cert.customer.shortName : ''" readonly="readonly">
        </div>
        <div v-show="!hasInvoice" class="five wide field">
          <label class="form-label">Clínica <span class="red text">*</span></label>
          <customer-picker ref="customerPicker" :authToken="authToken" @onPick="onPickCustomer" @onClear="onClearCustomer" />
        </div>    
        <div class="six wide field">
          <label class="form-label">Veterinário <span class="red text">*</span></label>
          <vet-picker ref="vetPicker" :authToken="authToken" @onPick="onPickVet" @onClear="onClearVet" />
        </div>            
        <div class="five wide field">
          <label class="form-label">Finalidade <span class="red text">*</span></label>
          <select-dropdown ref="finalityDropdown" @onChange="onChangeFinality" />
        </div>
      </div>                           
    </div>
  </div>

</template>

<script>

  import _ from "underscore"
  import SrvService from "@/services/srv-service"
  import { DatePicker, SelectDropdown, UserPicker, CustomerPicker, VetPicker } from "@/components"

  const FINALITY_OPTIONS = [
    { id: "unspecified", description: "Não especificada" },
    { id: "control", description: "Controle" },
    { id: "revaluation", description: "Reavaliação" },
  ]

  export default {
    
    name: "CertDataSegment",

    data() {
      return {
        loading: true,
        authToken: null,
        cert: {},
        services: [],
        srvService: new SrvService(),
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
      UserPicker,
      CustomerPicker,
      VetPicker,
    }, 

    mounted() {
      $(".cert-form-checkbox").checkbox()    
    },

    computed: {
      hasInvoice() {
        return (!!this.cert.customerInvoiceId || !!this.cert.employeeInvoiceId)
      },  
    },

    methods: {

      async init(cert) {

        this.loading = true

        try {

          this.authToken = await this.$store.state.auth.fbUser.getIdToken(true)
          this.services = await this.srvService.findAll()
          this.services = _.sortBy(this.services, "description")

          this.cert = this.$cloneObject(cert)
          
          this.$refs.datePicker.setDate(cert.date)
          this.$refs.serviceDropdown.setValues(this.services, this.cert.serviceId)
          this.$refs.userPicker.setSelected(cert.user)

          if (this.cert.serviceId)
            this.loadServiceTypes()

          if (cert.customer)
            this.$refs.customerPicker.setSelected(cert.customer)

          if (cert.vet)
            this.$refs.vetPicker.setSelected(cert.vet)

          this.$refs.finalityDropdown.setValues(FINALITY_OPTIONS, this.cert.finality)
          
        } catch (error) {
          
          this.$errorHandler(error)

        } finally {

          this.loading = false  
        }
      },

      onChangeDate(date) {
        this.cert.date = date
        this.onChange()
      },

      onChangeService(id) {

        if (this.loading)
          return

        this.cert.serviceId = id ? parseInt(id) : null
        this.cert.serviceTypeId = null

        this.onChange()
        this.loadServiceTypes()
      },

      loadServiceTypes() {

        let types = []
        let serviceTypes = []
        let icon = ""

        for (let service of this.services) {
          
          if (service.id == this.cert.serviceId) {

            serviceTypes = _.sortBy(service.types, "description")

            for (let type of serviceTypes) {

              icon = `<i class="${SrvService.TYPE_ICONS[type.icon].icon} m-r-5"></i>`           

              types.push({
                id: type.id,
                description: `${icon} ${type.description}`,
              })
            }
          }
        }

        this.$refs.serviceTypeDropdown.setValues(types, this.cert.serviceTypeId)
      },

      onChangeServiceType(id, value) {

        if (this.loading)
          return

        this.cert.serviceTypeId = id ? parseInt(id) : null

        const type = this.getServiceType(id)

        this.cert.value = id ? type.value : 0

        let finality = "unspecified"

        if (type.description.trim().toLowerCase() == "controle")
          finality = "control"

        this.$refs.finalityDropdown.setValues(FINALITY_OPTIONS, finality)

        this.onChange()
      },

      getServiceType(id) {
        
        for (let service of this.services) {
          if (service.id == this.cert.serviceId) {
            for (let type of service.types) {
              if (type.id == id)
                return type
            }
          }
        }

        return null
      },

      onPickUser(user) {   
        this.cert.user = user     
        this.cert.userId = user.id
        this.onChange()
      },

      onClearUser() {
        this.cert.user = null
        this.cert.userId = null
        this.onChange()
      },

      onPickCustomer(customer) {     
        this.cert.customer = customer   
        this.cert.customerId = customer.id
        this.onChange()
      },

      onClearCustomer() {
        this.cert.customer = null
        this.cert.customerId = null
        this.onChange()
      },

      onPickVet(vet) {        
        this.cert.vet = vet
        this.cert.vetId = vet.id
        this.onChange()
      },

      onClearVet() {
        this.cert.vet = null
        this.cert.vetId = null
        this.onChange()
      },

      onChangeFinality(id) {
        this.cert.finality = id
        this.onChange()
      },

      onChange() {
        this.cert = this.$cloneObject(this.cert)
        this.$emit("onChange", this.cert)
      },      
    },
  }

</script>